const dhomir = [
  [
    { ar: 'المُنْفَصِلُ', en: 'Separate', ms: 'Berpisah' },
    {
      ar: 'المُتَّصِلُ',
      en: 'Connect with word (Suffix)',
      ms: 'Bersambung (Merujuk kepada kepunyaan)',
    },
  ],
  [
    { ar: 'هُوَ', en: 'He', ms: 'Dia (L)' },
    { ar: 'هُ', en: 'His', ms: 'Dia (L) Punya' },
  ],
  [
    { ar: 'هُمَا', en: 'Both of Them (M)', ms: 'Mereka Berdua (L)' },
    { ar: 'هُمَا', en: 'Their (M)', ms: 'Mereka Berdua (L) Punya' },
  ],
  [
    { ar: 'هُمْ', en: 'They (M)', ms: 'Mereka Semua (L)' },
    { ar: 'هُمْ', en: 'Their (M)', ms: 'Mereka Semua (L) Punya' },
  ],
  [
    { ar: 'هِيَ', en: 'She', ms: 'Dia (P)' },
    { ar: 'هَا', en: 'Her', ms: 'Dia (P) Punya' },
  ],
  [
    { ar: 'هُمَا', en: 'Both of Them (F)', ms: 'Mereka Berdua (P)' },
    { ar: 'هُمَا', en: 'Their (F)', ms: 'Mereka Berdua (P) Punya' },
  ],
  [
    { ar: 'هُنَّ', en: 'They (F)', ms: 'Mereka Semua (P)' },
    { ar: 'هُنَّ', en: 'Their (F)', ms: 'Mereka Semua (P) Punya' },
  ],
  [
    { ar: 'أَنْتَ', en: 'You (M)', ms: 'Kamu (L)' },
    { ar: 'كَ', en: 'Your (M)', ms: 'Kamu (L) Punya' },
  ],
  [
    { ar: 'أَنْتُمَا', en: 'Both of You (M)', ms: 'Kamu Berdua (L)' },
    { ar: 'كُمَا', en: 'Your (M)', ms: 'Kamu Berdua (L) Punya' },
  ],
  [
    { ar: 'أنْتُمْ', en: 'All of You (M)', ms: 'Kamu Semua (L)' },
    { ar: 'كُمْ', en: 'Your (M)', ms: 'Kamu Semua (L) Punya' },
  ],
  [
    { ar: 'أَنْتِ', en: 'You (F)', ms: 'Kamu (P)' },
    { ar: 'كِ', en: 'Your (F)', ms: 'Kamu (P) Punya' },
  ],
  [
    { ar: 'أَنْتُمَا', en: 'Both of You (F)', ms: 'Kamu Berdua (P)' },
    { ar: 'كُمَا', en: 'Your (F)', ms: 'Kamu Berdua (P) Punya' },
  ],
  [
    { ar: 'أَنْتُنَّ', en: 'All of You (F)', ms: 'Kamu Semua (P)' },
    { ar: 'كُنَّ', en: 'Your (F)', ms: 'Kamu Semua (P) Punya' },
  ],
  [
    { ar: 'أَنَا', en: 'Me (M/F)', ms: 'Saya (L/P)' },
    { ar: 'يْ', en: 'My (M/F)', ms: 'Saya (L/P) Punya' },
  ],
  [
    { ar: 'نَحْنُ', en: 'Us (M/F)', ms: 'Kami (L/P)' },
    { ar: 'نَا', en: 'Our (M/F)', ms: 'Kami (L/P) Punya' },
  ],
];

export default dhomir;
